/* Moonrise Supply — motion layer: reveals sections as they enter view. */
(function () {
  var doc = document;
  var html = doc.documentElement;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  html.classList.add('mr-motion');

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mr-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
  }

  function reveal(section, index) {
    if (section.classList.contains('mr-reveal')) return;
    section.classList.add('mr-reveal');

    var rect = section.getBoundingClientRect();
    var inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView || !observer) {
      section.style.transitionDelay = Math.min(index, 4) * 90 + 'ms';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          section.classList.add('mr-in');
        });
      });
      setTimeout(function () {
        section.style.transitionDelay = '';
      }, 1400);
    } else {
      observer.observe(section);
    }
  }

  function setup() {
    var main = doc.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    for (var i = 0; i < sections.length; i++) reveal(sections[i], i);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  var main = doc.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    new MutationObserver(function () {
      setup();
    }).observe(main, { childList: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) setup();
  });
})();
